module.exports = __webpack_public_path__ + "static/media/pop-up.ff323155.png";